<ng-container *ngIf="job">
    <ion-row>
        <ion-col>
            <h2 class="dp-mt-m">{{ 'projects.jobs.details.weather.title' | translate }}</h2>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col>
            <ion-card class="weather-card">
                <ion-card-content>
                    <app-loading-indicator *ngIf="loading">{{ 'projects.jobs.details.weather.loading' | translate }}</app-loading-indicator>
                    <div class="no-data ion-text-center" *ngIf="!loading && job.weather.weatherInfo === null">
                        {{ 'projects.jobs.details.weather.no-data' | translate }}
                        <div class="dp-mt-s">
                            <ion-button (click)="loadWeatherNow()" size="small" *ngIf="changesAllowed">
                                <fa-icon icon="sun-cloud" slot="start"></fa-icon>
                                {{ 'projects.jobs.details.weather.load-btn' | translate }}
                            </ion-button>
                        </div>
                    </div>
                    <div
                        class="error ion-text-center"
                        *ngIf="!loading && job.weather.weatherInfo == 'load-on-sync'"
                        [innerHTML]="'projects.jobs.details.weather.load-err' | translate"
                    ></div>
                    <div
                        class="weather-data ion-text-center"
                        *ngIf="!loading && job.weather.weatherInfo != 'load-on-sync' && job.weather.weatherInfo != null"
                    >
                        <ion-row>
                            <ion-col>
                                <div class="weather-info-main dp-mb-s">
                                    {{ job.weather.weatherInfo.current.weather[0].description }}
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12" size-md="4">
                                <div class="weather-info">
                                    <div class="weather-info-value">{{ job.weather.weatherInfo.current.temp }} °</div>
                                    <div class="weather-info-heading">{{ 'projects.jobs.details.weather.temp' | translate }}</div>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="4">
                                <div class="weather-info">
                                    <div class="weather-info-value">{{ job.weather.weatherInfo.current.humidity }} %</div>
                                    <div class="weather-info-heading">{{ 'projects.jobs.details.weather.humidity' | translate }}</div>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="4">
                                <div class="weather-info">
                                    <div class="weather-info-value">
                                        {{ (job.weather.weatherInfo.current.wind_speed * 3.6).toFixed(1) }} km/h
                                    </div>
                                    <div class="weather-info-heading">{{ 'projects.jobs.details.weather.wind' | translate }}</div>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-end">
                                <div class="weather-date dp-mt-s">
                                    {{ 'projects.jobs.details.weather.ts' | translate }}
                                    {{ job.weather.weatherInfo.current.dt * 1000 | date: 'dd.MM.yyyy (HH:mm)' }}
                                </div>
                            </ion-col>
                        </ion-row>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</ng-container>
